import $ from 'jquery'
import Clipboard from 'clipboard'


export default {

  enable () {
    $('.clipboard').click((e) => {
      e.preventDefault()
      
    })
    new Clipboard('.clipboard', {
      text: function(elem) {
          alert('Le lien a été copié dans votre press-papier')
          return $(elem).attr('data-to-copy')
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/js/elements/clipboard.js